import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { defaultScreenOptions } from '@betty/navigation';
import { DepositNavigatorParamsList } from './DepositNavigator.types';
import { PAYMENT_SCREEN_OPTIONS } from '../../navigation';
import DepositScreen from '../../screens/DepositScreen';
import DepositPaymentsScreen from '../../screens/DepositPaymentsScreen/DepositPaymentsScreen';
import DepositLaunchScreen from '../../screens/DepositLaunchScreen/DepositLaunchScreen';
import DepositInteracURLScreen from '../../screens/DepositInteracURLScreen/DepositInteracURLScreen';
import PaymentStatusScreen from '../../screens/PaymentStatusScreen/PaymentStatusScreen';

const Deposit = createNativeStackNavigator<DepositNavigatorParamsList>();

function DepositNavigator() {
  return (
    <Deposit.Navigator screenOptions={defaultScreenOptions}>
      <Deposit.Screen
        name="DepositScreen"
        options={PAYMENT_SCREEN_OPTIONS}
        component={DepositScreen}
      />
      <Deposit.Screen
        name="DepositPaymentsScreen"
        options={PAYMENT_SCREEN_OPTIONS}
        component={DepositPaymentsScreen}
      />
      <Deposit.Screen
        name="DepositLaunchScreen"
        options={PAYMENT_SCREEN_OPTIONS}
        component={DepositLaunchScreen}
      />
      <Deposit.Screen
        name="DepositInteracURLScreen"
        options={PAYMENT_SCREEN_OPTIONS}
        component={DepositInteracURLScreen}
      />
      <Deposit.Screen
        name="PaymentStatusScreen"
        options={PAYMENT_SCREEN_OPTIONS}
        component={PaymentStatusScreen}
      />
    </Deposit.Navigator>
  );
}

export default DepositNavigator;
